import { IActionResponse, IActionResult, BaseClient, IPagedResult } from "../";
import { ApiParams } from "../../../assets/utils/lib";
import { CountyDto, GridCountyDto, SearchCountyDto } from "../../dto";
import { LookupDto } from "../../dto/account/lookupDto";

type LabelValueOption = { label: string; value: string };
export class CountyClient extends BaseClient {
    routes = ["system", "county"];

    async getCountyAsync(id: string | undefined): Promise<CountyDto> {
        const actions: string[] = ["GetCounty"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        const result: CountyDto = await this.getAsync<CountyDto>(actions, params);
        return result;
    }

    async getCountylookupQuery(): Promise<LabelValueOption[]> {
        const actions: string[] = ["getStatesAsync"];
        const result = await this.getAsync<LookupDto[]>(actions);

        return (result ?? []).map((state) => ({
            label: String(state.name),
            value: String(state.id),
        }));
    }

    async getCountysAsync(stateId?: string | undefined): Promise<CountyDto[]> {
        const actions: string[] = ["GetStateCounties"];
        const params: ApiParams[] = [new ApiParams("stateId", stateId, true)];

        const result: CountyDto[] = await this.getAsync<CountyDto[]>(actions, params);
        return result;
    }

    async searchCountysAsync(payload: SearchCountyDto | undefined): Promise<IPagedResult<GridCountyDto>> {
        const actions: string[] = ["SearchCounties"];
        const result: IPagedResult<GridCountyDto> = await this.postAsync<SearchCountyDto, GridCountyDto, IPagedResult<GridCountyDto>>(actions, payload);
        return result;
    }

    async saveCountyAsync(payload: CountyDto | undefined): Promise<IActionResult<CountyDto>> {
        const actions: string[] = ["SaveCounty"];
        return await this.postAsync<CountyDto>(actions, payload);
    }

    async deleteCountyAsync(id?: string | undefined): Promise<IActionResponse> {
        const actions: string[] = ["DeleteCounty"];
        const params: ApiParams[] = [new ApiParams("Id", id, true)];

        return await this.deleteAsync(actions, params);
    }
}
